export const paradiddle = {
  parts: {
    snare: {
      enabled: true
    }
  },
  measures: [
    {
      timeSig: {
        num: 2,
        type: 4,
      },
      parts: [
        {
          instrument: "snare",
          voices: [
            {
              notes: [
                {
                  notes: ["C5"],
                  ornaments: 'ra',
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  ornaments: 'l',
                  duration: 16,
                  velocity: 0.5,
                },
                {
                  notes: ["C5"],
                  ornaments: 'r',
                  duration: 16,
                  velocity: 0.5,
                },
                {
                  notes: ["C5"],
                  ornaments: 'r',
                  duration: 16,
                  velocity: 0.5,
                },
                {
                  notes: ["C5"],
                  ornaments: 'la',
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  ornaments: 'r',
                  duration: 16,
                  velocity: 0.5,
                },
                {
                  notes: ["C5"],
                  ornaments: 'l',
                  duration: 16,
                  velocity: 0.5,
                },
                {
                  notes: ["C5"],
                  ornaments: 'l',
                  duration: 16,
                  velocity: 0.5,
                }
              ],
              tuplets: [],
            },
          ],
        },
      ],
    },
  ],
}

export const smallMultiPart = {
  parts: {
    drumset: {
      enabled: true
    },
    tenors: {
      enabled: true
    }
  },
  measures: [
    {
      timeSig: {
        num: 4,
        type: 4,
      },
      parts: [
        {
          instrument: "drumset",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
              tuplets: [],
            },
          ],
        },
        {
          instrument: "tenors",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  ornaments: "adr",
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  ornaments: "cl",
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  ornaments: "f",
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
              tuplets: [],
            },
          ], 
        },
      ],
    },
  ],
};

export const EMPTY_SCORE = {
  parts: {
    drumset: {
      enabled: true
    }
  },
  measures: [
    {
      timeSig: {
        num: 4,
        type: 4,
      },
      parts: [
        {
          instrument: "drumset",
          voices: [
            {
              notes: [
                {
                  notes: [],
                  duration: 4,
                  velocity: 1.0,
                },
                {
                  notes: [],
                  duration: 4,
                  velocity: 1.0,
                },
                {
                  notes: [],
                  duration: 4,
                  velocity: 1.0,
                },
                {
                  notes: [],
                  duration: 4,
                  velocity: 1.0,
                }
              ],
              tuplets: [],
            },
          ],
        },
      ],
    },
  ],
};

export const smallSinglePart = {
  parts: {
    drumset: {
      enabled: true
    }
  },
  measures: [
    {
      timeSig: {
        num: 4,
        type: 4,
      },
      parts: [
        {
          instrument: "drumset",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
              tuplets: [],
            },
          ],
        },
      ],
    },
  ],
};

export const large = {
  parts: {
    drumset: {
      enabled: true
    },
    tenors: {
      enabled: true
    }
  },
  measures: [
    {
      timeSig: {
        num: 4,
        type: 4,
      },
      parts: [
        {
          instrument: "drumset",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
        {
          instrument: "tenors",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
      ],
    },
    {
      timeSig: {
        num: 4,
        type: 4,
      },
      parts: [
        {
          instrument: "drumset",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
        {
          instrument: "tenors",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
      ],
    },
    {
      timeSig: {
        num: 4,
        type: 4,
      },
      parts: [
        {
          instrument: "drumset",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
        {
          instrument: "tenors",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
      ],
    },
    {
      timeSig: {
        num: 4,
        type: 4,
      },
      parts: [
        {
          instrument: "drumset",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
        {
          instrument: "tenors",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
      ],
    },
    {
      timeSig: {
        num: 4,
        type: 4,
      },
      parts: [
        {
          instrument: "drumset",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
        {
          instrument: "tenors",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
      ],
    },
    {
      timeSig: {
        num: 4,
        type: 4,
      },
      parts: [
        {
          instrument: "drumset",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
        {
          instrument: "tenors",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
      ],
    },
    {
      timeSig: {
        num: 4,
        type: 4,
      },
      parts: [
        {
          instrument: "drumset",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
        {
          instrument: "tenors",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
      ],
    },
    {
      timeSig: {
        num: 4,
        type: 4,
      },
      parts: [
        {
          instrument: "drumset",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
        {
          instrument: "tenors",
          voices: [
            {
              notes: [
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["C5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4"],
                  duration: 16,
                  velocity: 1.0,
                },
                {
                  notes: ["F4", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["C5", "E5"],
                  duration: 8,
                  velocity: 1.0,
                },
                {
                  notes: ["E5"],
                  duration: 8,
                  velocity: 1.0,
                },
              ],
            },
          ],
          tuplets: [],
        },
      ],
    },
  ],
};
